var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vm-state",class:_vm.badge.class,attrs:{"title":_vm.badge.label}})}
var staticRenderFns = []

export { render, staticRenderFns }